import { Input, Output, EventEmitter, Component, OnInit } from "@angular/core";
import { ModelService } from "../Services/model.service";
import { ClassificationSystem } from "../Model/classification/ClassificationSystem";
import { ClassificationClass } from '../Model/classification/ClassificationClass';
import { ClassificationClassTree } from '../Model/classification/ClassificationClassTree';
import { Router } from "@angular/router";
import { LoginService } from "../Services/login.service";
import { ClassificationService } from "../Services/classification.service";
import { CatalogService } from "../Services/CatalogManagement/catalog.service";

@Component({
    selector: "productClassification",
    templateUrl: "productClassification.component.html",
    standalone: false
})
export class ProductClassificationComponent implements OnInit {

  @Input() addClassificationDisabled: boolean = true;
  @Output() windowClose = new EventEmitter<any>();
  @Output() addClassificationFeatures = new EventEmitter<ClassificationClass>();
  selectedClassificationSystem: ClassificationSystem;
  selectedClassificationClass: ClassificationClass;
  classificationSystems: ClassificationSystem[] = [];
  classificationClasses: ClassificationClass[] = [];
  loadingClassificationClasses: boolean = false;

  constructor(private loginService: LoginService, private router: Router,
    private classificationService: ClassificationService, private catalogService: CatalogService) {

  }

  ngOnInit(): void {
    if (this.loginService.currentUser == null) {
      this.router.navigate(["/"]);
      return;
    }
    this.classificationSystems = this.catalogService.catalog.classificationSystems;
  }

  async refresh() {
    if (this.selectedClassificationSystem != undefined) {
      this.loadingClassificationClasses = true;
      this.classificationClasses = await this.classificationService.getClassificationClassesWithoutFeatures(this.selectedClassificationSystem.id);
      this.loadingClassificationClasses = false;
    } else {
      this.classificationClasses = [];
    }
  }

  classificationSystemChanged(e) {
    this.selectedClassificationClass = undefined;
    this.addClassificationDisabled = true;

    this.refresh();
  }

  onClassTreeSelectionChanged(e) {
    const selectedRows = e.selectedRowsData;

    if (selectedRows && selectedRows.length) {
      this.selectedClassificationClass = selectedRows[0];
      this.addClassificationDisabled = !selectedRows[0].assignable;
    } else {
      this.selectedClassificationClass = undefined;
      this.addClassificationDisabled = true;
    }
  }

  addClassification() {
    this.addClassificationFeatures.emit(this.selectedClassificationClass);
    this.windowClose.emit();
  }
}


